import { SVGProps } from '@components/Icon/types';

export const Search = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 2)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.97832 0C3.58564 0 0 3.58564 0 7.97832C0 12.371 3.58564 15.9566 7.97832 15.9566C9.77777 15.9566 11.4364 15.3484 12.7758 14.3337L13.0278 14.1429L18.6438 19.7577C18.7164 19.8333 18.8033 19.8937 18.8995 19.9353C18.9957 19.9769 19.0993 19.9989 19.2041 20C19.3089 20.001 19.4129 19.9812 19.5099 19.9415C19.6069 19.9019 19.6951 19.8433 19.7692 19.7692C19.8433 19.6951 19.9019 19.6069 19.9415 19.5099C19.9812 19.4129 20.001 19.3089 20 19.2041C19.9989 19.0993 19.9769 18.9957 19.9353 18.8995C19.8937 18.8033 19.8334 18.7163 19.7578 18.6437L19.7524 18.6386L14.1429 13.0278L14.3337 12.7758C15.3484 11.4364 15.9566 9.77777 15.9566 7.97832C15.9566 3.58564 12.371 0 7.97832 0ZM1.57558 7.97832C1.57558 4.42855 4.42855 1.57558 7.97832 1.57558C11.5281 1.57558 14.3811 4.42855 14.3811 7.97832C14.3811 9.68268 13.7185 11.223 12.6422 12.367L12.6186 12.3921L12.5907 12.4123C12.523 12.4613 12.4635 12.5208 12.4145 12.5885L12.3944 12.6163L12.3694 12.6398C11.2252 13.7175 9.68392 14.3811 7.97832 14.3811C4.42855 14.3811 1.57558 11.5281 1.57558 7.97832Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'search';
